/*
 * @Author: zly
 * @Date: 2021-07-26 09:48:02
 * @LastEditTime: 2022-03-30 11:27:17
 * @LastEditors: 汪俊洪
 * @Description: 表格底部合计
 */

import { add } from "./numberComputed";
import { formatePrice } from "./formatePrice";
const tableTotal = function (param, tableTotalList) {
  console.log("tableTotal");
  const { columns, data } = param;
  const sums = Array.from({ length: columns.length || 0 }, () => "");
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "合计";
      return;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (!tableTotalList.hasOwnProperty(column.label)) {
      return "";
    }
    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      sums[index] = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return add(prev, curr);
        } else {
          return prev;
        }
      }, 0);
      console.log(column);

      if (tableTotalList[column.label] === "money") {
        sums[index] = formatePrice((sums[index] || 0).toFixed(2));
      }
    } else {
      sums[index] = "-";
    }
  });
  return sums;
};

export default tableTotal;

export const tableAllTotal = ({ columns }, tableAllTotalList) => {
  const keys = Object.keys(tableAllTotalList);
  const alls = Object.values(tableAllTotalList);
  return columns.map(({ label }, index) => {
    if (index === 0) {
      return ["总计"];
    } else if (keys.includes(label)) {
      return formatePrice(+alls[keys.indexOf(label)]);
    } else {
      return "";
    }
  });
};
